/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { Dayjs } from 'dayjs';

export type ModelVariant = 'model' | 'dataset';
export type ModelWorkloadType = 'endpoint' | 'finetuning';

export enum DedicatedModelType {
  HuggingFace = 'HUGGING_FACE',
  Wandb = 'WANDB',
  Native = 'NATIVE',
}

export interface NativeModel {
  modelId: string;
  modelName?: string | null;
  version?: NativeModelVersion[] | null;
}

export interface NativeModelVersion {
  id: string;
  name: string;
  uploadedAt?: string | null;
}

export interface Adapter {
  id: string;
  name?: string | null;
  route?: string | null;
  createdAt?: Dayjs | null;
  editDisabled?: boolean | null;
}

export enum DedicatedModelFileStructType {
  Directory = 'DIRECTORY',
  File = 'FILE',
}

export interface DedicatedModelFileStructNode {
  path: string;
  size?: number;
  digest?: string;
  type: DedicatedModelFileStructType;
}

export interface HfModelRepo {
  name: string;
  // imageUrl?: string;
  downloadCount?: number;
  isGated?: boolean;
  isPrivate?: boolean;
}

export interface HfModelRepoGitInfo {
  branches: Array<{ name: string; commit: string }>;
  tags: Array<{ name: string; commit: string }>;
}
